export type BillingInterval = 'monthly' | 'yearly' | 'quarterly';

export function toBillingInterval(raw?: string | null): BillingInterval {
  const value = (raw || '').toLowerCase()
  if (value === 'year' || value === 'yearly') return 'yearly'
  if (value === 'quarter' || value === 'quarterly') return 'quarterly'
  return 'monthly'
}

export function isCurrentPlanSelection(
  currentPlan: string | null,
  currentInterval: BillingInterval,
  targetPlan: string,
  targetInterval: BillingInterval,
): boolean {
  if (!currentPlan || currentPlan !== targetPlan) return false
  if (targetPlan === 'free') return true
  return currentInterval === targetInterval
}

export function buildCheckoutUrl(options: {
  plan: string
  interval?: BillingInterval
  source?: string
}): string {
  const params = new URLSearchParams({
    plan: options.plan,
    interval: options.interval || 'monthly',
  })
  if (options.source) params.set('source', options.source)
  return `/billing/checkout?${params.toString()}`
}

export function buildPaidPlanCtaUrl(options: {
  plan: string
  interval?: BillingInterval
  source?: string
  isAuthenticated: boolean
}): string {
  if (options.isAuthenticated) {
    return buildCheckoutUrl(options)
  }
  return buildRegistrationUrl(options)
}

export function proceedToCheckout(
  planId: string,
  interval: BillingInterval = 'monthly',
  extraParams?: Record<string, string>,
): void {
  const params = new URLSearchParams({
    plan: planId,
    interval,
    ...extraParams,
  });
  window.location.assign(`/billing/checkout?${params.toString()}`);
}

/**
 * Legacy Genetic Insight Pass URLs → 3-month Basic access checkout.
 * One upfront term (not a recurring monthly subscription). Access ends after 3 months;
 * reminder emails offer continuing on a regular monthly plan.
 */
export function legacyInsightPassCheckoutUrl(source?: string): string {
  const params = new URLSearchParams({
    plan: 'basic',
    interval: 'quarterly',
    source: source || 'legacy_insight_pass',
  });
  return `/billing/checkout?${params.toString()}`;
}

export function buildRegistrationUrl(options?: {
  plan?: string;
  product?: string;
  interval?: BillingInterval;
  source?: string;
}): string {
  const params = new URLSearchParams();
  if (options?.plan) params.set('plan', options.plan);
  if (options?.product) params.set('product', options.product);
  if (options?.interval) params.set('interval', options.interval);
  if (options?.source) params.set('source', options.source);
  const query = params.toString();
  return query ? `/register?${query}` : '/register';
}
